module.exports = __webpack_public_path__ + "fa-brands-400.13db00b7a34fee4d819a.eot";


//////////////////
// WEBPACK FOOTER
// E:/SafeCloud-FrontEnd/WebConsorcioPimentel/src/assets/plugins/FontAweson/webfonts/fa-brands-400.eot
// module id = ../../../../../src/assets/plugins/FontAweson/webfonts/fa-brands-400.eot
// module chunks = styles